
































































































































































































  import { Component, Vue, Prop } from "vue-property-decorator";
  import ReusableButton from "@/components/ReusableButton.vue";
  import {
    Configuration,
    SelectedCountry,
    RedCapital,
    TitleTemplateDashboard,
  } from "@/configuration";
  import { mapState } from "vuex";
  import API from "@/api";
  import { EventBus } from "@/main";
  import { Compania } from '@/models/Company';
  import ShowLoading from "@/components/panel/ShowLoading.vue";
  import UploadImg from "@/components/uploadImg/UploadImg.vue";
import { orderComunas } from "@/utils";

  @Component({
    metaInfo: {
      title: "Editar empresa",
      titleTemplate: TitleTemplateDashboard,
      htmlAttrs: {
        // @ts-ignore
        lang: RedCapital[SelectedCountry].Lang,
      },
    },
  computed: {
			...mapState(["setOpenMenuPanel"]),
			setOpenMenuPanel(){
				return this.$store.state.openMenuPanel;
			},
  },
  data() {
    return {
      aux: null,
      beforeImagesSolicitud: [],
      beforeImagesSolicitudParcial:[],
      uploadImgs: null,
      RedCapital,
      valid: true,
      showCheck: {
        desc: false,
      },
      textAreaMax150: '',
      isLoading: false,
      SelectedCountry,
      company: {} as Compania,
      regions: [],
      communes: [],
      siiPassword: false,
      rules: {
        notEmpty: [(v: string) => !!v || "Este campo es requerido"],
        direcc: [(v: string) => !!v || "La dirección es requerida"],
        cm: [(v: string) => !!v || "La comuna es requerida"],
        rg: [(v: string) => !!v || "La región es requerida"],
        noVacioTextAreaGeneral: [
						// @ts-ignore
						v => {
							if(!v || v.trim() === ''){
								return 'Campo requerido'
							}else if(v.trim().length < 10){
								return 'Ingrese al menos 10 caracteres'
							}else if(v.trim().length >= 150){
								this.$data.company.descripcion = this.$data.company.descripcion.trim();
								return true
							}else{
								return true
							}
						}
					],
        noEmail:[
						(v: any) => !!v || 'E-mail es requerido',
						(v: any) => /^.+@.+\..+/gi.test(v) || 'El e-mail tiene que ser valido',
						(v: any) => !!v || "Ingrese un valor"
					],
        noPhone: [
						(v: any) => !!v || 'Teléfono es requerido',
						(v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros",
						(v: any) => v.length > 8 || "Minimo 9 caracteres",
						(v: any) => !!v || "Ingrese un valor",
					],
        noSelect: [
						// @ts-ignore
						v => {
							if(!v || v == 0 || v == null || v == undefined){
								return 'Campo requerido'
							}else{
								return true
							}
						}
					],
      },
      clave: null,
      loadData: {
        comunas: false,
        edit: false
      }
    };
  },
  async beforeMount() {
    //@ts-ignore
    this.$data.company = await API.getCompany(this.$props.companyId);
    /* Imgs */
    this.$data.aux = await API.stateBusiness(this.$data.company.rut.split('.').join(''));
    if(typeof this.$data.aux.data.data.imagenes === 'object'){
      this.$data.aux.data.data.imagenes = Object.values(this.$data.aux.data.data.imagenes);
    }
    if(this.$data.aux.data.data.imagenes.length > 3){
      this.$data.beforeImagesSolicitudParcial = this.$data.aux.data.data.imagenes.slice(this.$data.aux.data.data.imagenes.length - 3);
    }else{
      this.$data.beforeImagesSolicitudParcial = this.$data.aux.data.data.imagenes;
    }
    this.$data.company.pais_id = 1;
    this.$data.regions = await API.getRegions();
    this.$data.loadData.edit = true;
    setTimeout(()=>{
      this.$data.beforeImagesSolicitud = this.$data.beforeImagesSolicitudParcial;
		})
  },
  methods: {
    emitImagenes(data) {
      this.$data.uploadImgs = data;
    },
    editCompany() {
      // @ts-ignore
      if (this.$refs.editForm.validate()) {
        this.$data.isLoading = true;
        // validar sii
        if(this.$data.company.clavesii != null  && this.$data.company.clavesii != ''){
          API.factoring
            .sii(this.$data.company.id, this.$data.company.clavesii, this.$data.company.clavesii)
            .then((res)=>{
              API.editCompany(this.$data.company)
                .then((result) => {
                  if(this.$data.uploadImgs != null){
                    API.accion.uploadImages(this.$store.state.user.id, this.$data.company.id, this.$data.uploadImgs)
                      .then((resA: any) => {})
                      .catch((error:any) => {})
                  }
                  EventBus.$emit("alerts", true,'¡Atención!',"Tus datos fueron actualizados con éxito!")
                  setTimeout(() => {
                    EventBus.$emit("alerts", false,'',"")
                    this.$router.push({
                      path: "/panel-facto/empresas",
                    });
                  }, 2000);
                })
                .catch((error) => {
                  EventBus.$emit("alertsError", true,'¡Atención!',"Error al actualizar, intente más tarde!")
                  setTimeout(() => {
                    EventBus.$emit("alertsError", false,'',"")
                  }, 2000);
                })
                .finally(()=>{
                  this.$data.isLoading = false;
                })    
            })
            .catch((err)=>{
              this.$data.isLoading = false;
              this.$data.company.clavesii = '';
              EventBus.$emit("alertsError", true,'¡Atención!',err.response.data.mensaje.password[0])
              setTimeout(() => {
                EventBus.$emit("alertsError", false,'',"")
              }, 2000);
            })
        }else{
          API.editCompany(this.$data.company)
          .then((result) => {
            if(this.$data.uploadImgs != null){
              API.accion.uploadImages(this.$store.state.user.id, this.$data.company.id, this.$data.uploadImgs)
                .then((resA: any) => {})
                .catch((error:any) => {})
            }
            EventBus.$emit("alerts", true,'¡Atención!',"Tus datos fueron actualizados con éxito!")
            setTimeout(() => {
              EventBus.$emit("alerts", false,'',"")
              this.$router.push({
                path: "/panel-facto/empresas",
              });
            }, 2000);
          })
          .catch((error) => {
            EventBus.$emit("alertsError", true,'¡Atención!',"Error al actualizar, intente más tarde!")
            setTimeout(() => {
              EventBus.$emit("alertsError", false,'',"")
            }, 2000);
          })
          .finally(()=>{
            this.$data.isLoading = false;
          })
        }
      }
    },
    async updateCommunes() {
      this.$data.communes = await API.getCommunes(this.$data.company.region_id);
      this.$data.company.comuna_id = this.$data.communes[0].id;
    },
  },
  watch: {
    'company.descripcion' (val: any){
				if(val != null && val.trim().length <= 150 && val.trim().length > 9){
					if(this.$data.textAreaMax150 != ''){
						this.$data.textAreaMax150 = '';
					}
					if(val.trim().length == 150){
						this.$data.textAreaMax150 = val 
					}
					this.$data.showCheck.desc = true;
				} else {
					this.$data.showCheck.desc = false;
				}
				if(val != null && val.trim().length > 150){
					this.$data.company.descripcion = '';
					setTimeout(() => {
						this.$data.company.descripcion = this.$data.textAreaMax150;	
					});
					this.$data.showCheck.desc = false;
				}
			},
    "company.region_id"(id: number) {
				if(id != undefined || id != null){
					this.$data.loadData.comunas = true;
					API.getCommunes(id)
						.then((res: any) => {
							this.$data.communes = orderComunas(res);
						})
						.catch((err: any) => {})
						.finally(() => {
							this.$data.loadData.comunas = false;
						})
				}
			},
    'company.telefono'(val){
				if(val && val.substr(0,2) == '56'){
					this.$data.company.telefono = val.slice(2);
				}
			},
  },
  components: {
    ReusableButton,
    ShowLoading,
    UploadImg
  },
})
export default class EditBusiness extends Vue {
  @Prop() companyId!: number;
}
